exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer .inner[data-v-4d8dbb0f],.outer[data-v-4d8dbb0f]{width:100%;height:100%}.image-placeholder[data-v-4d8dbb0f]{background:linear-gradient(to top left,transparent 0,transparent calc(50% - .8px),#000 50%,transparent calc(50% + .8px),transparent),linear-gradient(to top right,transparent 0,transparent calc(50% - .8px),#000 50%,transparent calc(50% + .8px),transparent)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d8dbb0f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/WidgetImage.vue
// module id = 114
// module chunks = 0